import { G1N6DamageType, G1N6DamageTypeCategory } from './types'

const structuralDamageTypes: G1N6DamageType[] = [
  { id: 'crack', label: 'Crack/Fracture' },
  { id: 'holing', label: 'Holing' },
  { id: 'tripped', label: 'Tripped stiffener' },
  { id: 'bimetallic', label: 'Bimetallic strip' },
  { id: 'buckling', label: 'Buckling/deformation' },
  { id: 'deterioration', label: 'Deterioration to Equipment Foundation' },
]

const coatingDamageTypes: G1N6DamageType[] = [
  { id: 'general', label: 'General Corrosion' },
  { id: 'delimination', label: 'Delimination' },
  { id: 'disbondment', label: 'Disbondment' },
  { id: 'amine-blush', label: 'Amine blush' },
  { id: 'mud-cracking', label: 'Mud cracking' },
  { id: 'blushing', label: 'Blushing' },
  { id: 'runs', label: 'Runs' },
  { id: 'sagging', label: 'Sagging' },
  { id: 'chalking', label: 'Chalking' },
  { id: 'checking', label: 'Checking' },
  { id: 'fish-eyes', label: 'Fish Eyes' },
  { id: 'orange-peel', label: 'Orange Peel' },
  { id: 'overspray', label: 'Overspray' },
  { id: 'pinholing', label: 'Pinholing' },
  { id: 'scaling', label: 'Scaling/exfoliation' },
  { id: 'pitting', label: 'Pitting' },
  { id: 'blistering', label: 'Blistering' },
]

const outfittingDamageTypes: G1N6DamageType[] = [
  { id: 'welds', label: 'Welds deteriorated' },
  { id: 'anode', label: 'Depleted anode' },
  { id: 'insulation', label: 'Insulation damaged' },
]

export const g1n6DamageCategories: G1N6DamageTypeCategory[] = [
  {
    id: 'Structural',
    label: 'Structural',
    hasLocalizedScattered: false,
    damageTypes: structuralDamageTypes,
    components: [
      {
        id: 'framing',
        label:
          'Framing - Stiffener, Beam, Non-tight Reinforcing Rings, Coamings, Collars, and Similar Elements',
      },
      {
        id: 'penetrations',
        label:
          'Penetrations - Piping Sleeves, HVAC Duct Coamings, Multi-Cable Transits (MCT) and Stuffing Tubes',
      },
      {
        id: 'piping-discharge',
        label: 'Piping Discharge Waster Plate',
      },
      {
        id: 'plate-decks',
        label: 'Plate - Decks and Platforms (Underside)',
      },
      {
        id: 'plate-shell',
        label: 'Plate - Shell',
      },
      {
        id: 'stanchions',
        label: 'Stanchions',
      },
    ],
  },
  {
    id: 'Coating',
    label: 'Coating',
    hasLocalizedScattered: true,
    damageTypes: coatingDamageTypes,
    components: [
      {
        id: 'overhead',
        label: 'Overhead',
      },
      {
        id: 'bulkheads-shell',
        label: 'Bulkheads/Shell',
      },
      {
        id: 'stiffeners',
        label: 'Stiffeners',
      },
      {
        id: 'deck-bilge',
        label: 'Deck/Bilge',
      },
    ],
  },
  {
    id: 'Outfitting',
    label: 'Outfitting',
    hasLocalizedScattered: false,
    damageTypes: outfittingDamageTypes,
    components: [
      {
        id: 'ladder',
        label: 'Ladder - support structure or brackets',
      },
      {
        id: 'piping',
        label:
          'Piping or Piping Components (Valves, Strainers, Flex Hoses, etc) - hangers or supports',
      },
      {
        id: 'seachest',
        label: 'Seachest and Overboard Discharge hull penetrations',
      },
      {
        id: 'structural-closures',
        label:
          'Structural Closures - Manhole Covers, Doors, Hatches, and Scuttles',
      },
      {
        id: 'cathodic-protection',
        label: 'Cathodic Protection - Zinc or Aluminum Anode',
      },
      {
        id: 'insulated-structure',
        label: 'Insulated Structure - Thermal, Acoustic, Fire',
      },
      {
        id: 'hvac-piping',
        label: 'HVAC and Piping System Insulation and Lagging',
      },
    ],
  },
]
